import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';
import { PersistentPanes } from './PersistentPanes';
import { ModeDrawer } from './ModeDrawer';
import { useNavTracking } from './useNavTracking';
import { useScrollToTopOnNav } from './useScrollToTopOnNav';
import { useAuth } from '@/shared/state/auth-context';

export function AppShell() {
  useNavTracking();
  useScrollToTopOnNav();
  const { currentUser } = useAuth();
  // One-tick grace period: AuthProvider hydrates from localStorage in a useEffect,
  // so on first render currentUser is null even when a session exists. Wait one
  // tick before redirecting so we don't kick hydrated users to /login.
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => { setHydrated(true); }, []);
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (hydrated && !currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="mx-auto max-w-md min-h-screen flex flex-col bg-velvet text-white/90">
      <TopBar onOpenDrawer={() => setDrawerOpen(true)} />
      {/* pt/pb compensate for fixed TopBar (~56px) and BottomNav (~88px incl. protruding center button)
          so content isn't underlaid and tap targets at the top/bottom remain reachable. */}
      <main className="flex-1 pt-14 pb-24">
        <PersistentPanes />
      </main>
      <BottomNav onOpenDrawer={() => setDrawerOpen(true)} />
      <ModeDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
    </div>
  );
}
